var React = require('react');

function FavoritesActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 2l3.233 6.55 7.229 1.05-5.231 5.1 1.235 7.2L12 18.5l-6.466 3.4 1.235-7.2-5.23-5.1 7.228-1.05L12 2z"}));
}

FavoritesActive.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"var(--palette-primary)"};

module.exports = FavoritesActive;

FavoritesActive.default = FavoritesActive;
